import { useState } from 'react';
import {
  Alert, Box, Button, Card, CardContent, CircularProgress, Stack, TextField, Typography,
} from '@mui/material';
import { api } from '../api/client';

export function ChangePasswordPage() {
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);
  const [ok, setOk] = useState(false);

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setErr(null);
    setOk(false);
    if (next.length < 8) { setErr('New password must be at least 8 characters.'); return; }
    if (next !== confirm) { setErr('New passwords do not match.'); return; }
    if (next === current) { setErr('New password must differ from current.'); return; }
    setBusy(true);
    try {
      await api.post('/api/auth/change-password', {
        CurrentPassword: current, NewPassword: next,
      });
      setOk(true);
      setCurrent(''); setNext(''); setConfirm('');
    } catch (ex: unknown) {
      const msg = (ex as { response?: { data?: { error?: string; message?: string } } })?.response?.data?.error
        ?? (ex as { response?: { data?: { message?: string } } })?.response?.data?.message
        ?? (ex as Error).message;
      setErr(msg);
    } finally {
      setBusy(false);
    }
  };

  return (
    <Box sx={{ maxWidth: 480 }}>
      <Typography variant="h5" sx={{ fontWeight: 700, mb: 0.5 }}>Change password</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Choose a new password for your account.
      </Typography>
      <Card>
        <CardContent>
          <Stack component="form" spacing={2} onSubmit={onSubmit}>
            <TextField
              label="Current password" type="password" value={current} required size="small"
              autoComplete="current-password"
              onChange={(e) => setCurrent(e.target.value)}
            />
            <TextField
              label="New password" type="password" value={next} required size="small"
              autoComplete="new-password"
              helperText="Minimum 8 characters"
              onChange={(e) => setNext(e.target.value)}
            />
            <TextField
              label="Confirm new password" type="password" value={confirm} required size="small"
              autoComplete="new-password"
              onChange={(e) => setConfirm(e.target.value)}
            />
            {err && <Alert severity="error">{err}</Alert>}
            {ok && <Alert severity="success">Password updated.</Alert>}
            <Button type="submit" variant="contained" size="large" disabled={busy}
                    startIcon={busy ? <CircularProgress size={18} /> : null}>
              {busy ? 'Updating...' : 'Update password'}
            </Button>
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
}
